import React from 'react';
import { Elements } from '@stripe/react-stripe-js';

import { useStripePromise } from './load';

export const StripeElements: React.FC = ({ children }) => {
  const stripePromise = useStripePromise();

  return <Elements stripe={stripePromise}>{children}</Elements>;
};
